module.exports = __webpack_public_path__ + "img/banner.38f75854.png";